<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <div id="notfound">
                            <div class="notfound">
                                <div class="notfound-404">
                                    <h3>Oops! Page not found</h3>
                                    <h1><span>4</span><span>0</span><span>4</span></h1>
                                </div>
                                <h2>we are sorry, but the page you requested was not found</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import "./../assets/css/errors.css";
import Vue from "vue";

export default {
    name: 'error404',
    data() {
        return {}
    },
    methods: {
    },
    computed: {}
    ,
    mounted() {
    }
}
</script>